exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ng-animate.item:not(.left):not(.right){transition:left 0s ease-in-out}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/angular-ui-bootstrap/src/carousel/carousel.css
// module id = 469
// module chunks = 1